import { types } from 'mobx-state-tree';

const PaymentProvider = types.model('PaymentProvider', {
  description: types.maybeNull(types.string),
  icon: types.maybeNull(types.string),
  id: types.identifier,
  title: types.maybeNull(types.string),
});

export default PaymentProvider;
